import React from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import "./custom-confirm-alert.css"; // Make sure this CSS file exists

const showConfirmAlert = ({ title, message, buttons }) => {
  confirmAlert({
    closeOnClickOutside: false, // ✅ Prevents closing on outside click
    customUI: ({ onClose }) => {
      return (
        <div className="custom-alert-container">
          <h1 className="custom-alert-title">{title}</h1>
          <p className="custom-alert-message">{message}</p>
          <div className="custom-alert-buttons">
            {buttons?.map((btn, index) => (
              <button
                key={index}
                className={btn.className}
                onClick={() => {
                  (btn.onClick || (() => {}))();
                  onClose();
                }}
              >
                {btn.label}
              </button>
            ))}
          </div>
        </div>
      );
    },
  });
};

export default showConfirmAlert;
